<template>
  <div class="env-tip" v-if="clientEnv || nodeEnv">
    <span>页面环境为：{{ envMap[clientEnv] || envMap[nodeEnv]}}；node环境为：{{ envMap[nodeEnv] || '正式环境' }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const ENV_DEV = 'dev';
const ENV_TEST = 'test';
const ENV_FORMAL = 'formal';
const ENV_MAP = {
  [ENV_TEST]: '测试环境',
  [ENV_DEV]: '本地环境',
  [ENV_FORMAL]: '正式环境',
};

export default {
  name: 'EnvTip',
  data() {
    return {
      envMap: ENV_MAP,
    };
  },
  computed: {
    ...mapState(['curEnv']),
    clientEnv() {
      return process.env.NODE_ENV === ENV_DEV ? ENV_DEV : '';
    },
    nodeEnv() {
      return window.configEnv || this.curEnv;
    },
  },
};
</script>
<style scoped>
.env-tip {
  pointer-events: none;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: .4rem;
  background-color: rgba(0, 0, 0, .3);
  z-index: 9999;
  font-size: .12rem;
  line-height: .4rem;
  text-align: center;
  color: #fff;
}
</style>